import { UntypedFormControl } from '@angular/forms';

/**
 * Checks if the field has at least one value
 * @param field
 * @returns {object | null}
 * @constructor
 */
export function AtLeastOneValidator(field: UntypedFormControl): { notenoughitems: boolean } {
    if (!field.value || (field.value && Array.isArray(field.value) && field.value.length < 1)) {
        return { notenoughitems: true };
    }
    return null;
}
